import { Table, Typography } from 'antd';

const { Text } = Typography;

const dataSource = [
  {
    key: '1',
    serial: 1,
    poNo: 'PO123456',
    amount: 200000,
    matCost: 150000,
    date: '23-10-2023',
    dueDate: '26-10-2023',
  },
  {
    key: '2',
    serial: 2,
    poNo: 'PO456123',
    amount: 500000,
    matCost: 400000,
    date: '01-11-2023',
    dueDate: '04-11-2023',
  },
];

const columns = [
  {
    title: 'Serial No.',
    dataIndex: 'serial',
    key: 'serial',
  },
  {
    title: 'PO Number',
    dataIndex: 'poNo',
    key: 'poNo',
  },
  {
    title: 'PO Amount',
    dataIndex: 'amount',
    key: 'amount',
  },
  {
    title: 'Material Cost',
    dataIndex: 'matCost',
    key: 'matCost',
  },
  {
    title: 'PO Date',
    dataIndex: 'date',
    key: 'date',
  },
  {
    title: 'PO Due Date',
    dataIndex: 'dueDate',
    key: 'dueDate',
  },
];

const SupplyChainFormatTable = () => {
  return (
    <>
      <Text style={{ display: 'block', color: '#40566D', marginBottom: 12, marginTop: 40, fontSize: 14 }}>
        Ensure your summary sheet follows this format:
      </Text>
      <div className="invoice-format-table">
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={false}
          bordered
          scroll={{ x: 'max-content' }}
        />
      </div>
    </>
  );
};

export default SupplyChainFormatTable;
